/* Shopify handles validation and delivery. Only announce returned status here. */
if (!customElements.get('bm-team-studio')) {
  customElements.define('bm-team-studio', class extends HTMLElement {
    connectedCallback() {
      if (this.statusFrame) cancelAnimationFrame(this.statusFrame);
      this.statusFrame = requestAnimationFrame(() => {
        this.statusFrame = null;
        const status = this.querySelector('[data-contact-errors], [data-contact-success]');
        if (status && this.isConnected) status.focus();
      });
    }
    disconnectedCallback() {
      if (this.statusFrame) cancelAnimationFrame(this.statusFrame);
      this.statusFrame = null;
    }
  });
}
